import * as React from 'react';
import Select from './Select';

interface Props {
  dataInvalidMessage?: string;
  id?: string;
  forceHighlightErrors?: boolean;
  value?: string;
  label?: string;

  // Adding a property to add external css class. 

  divClassName?: string;
  labelClassName?: string;
  cardTypeSelectClassName?: string;
  selectClassName?: string;
  cardTypeList: string[];

  validator?: (s: string) => boolean;
  onChange(value: string): void;
}

interface SelectOption {
  label: string;
  value: string;
}

interface State {
  wasChanged: boolean;
  cardType: string;
}

class SelectCardType extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      wasChanged: false,
      cardType: props.value ? props.value : ''
    };
  }

  renderCardTypeOption(value: string, index: number) {
    return (
      <option key={index} value={value}>
        {value}
      </option>
    );
  }

  renderCardTypeOptions() {
    return this.props.cardTypeList.map(this.renderCardTypeOption);
  }

  handleCardTypeChange(cardType: string) {
    this.setState({ cardType : cardType });
  }

  render() {
    const value = this.props.value ? this.props.value : '';

    let valid: boolean = true;

    if ((this.state.wasChanged || this.props.forceHighlightErrors) && this.props.validator && this.props.validator(value) === false) {
      valid = false;
    }

    // Check if external css properties comes from parent
    let divUserClass = this.props.divClassName === null ? '' : this.props.divClassName;
    let cardTypeSelectUserClass = this.props.cardTypeSelectClassName === null ? '' : this.props.cardTypeSelectClassName;

    return (
      <>
        <div className={`input-field ${divUserClass}`} id={`${this.props.id}-input-field`}>
        <Select
          selectClassName={this.props.selectClassName}
          value={value}
          onChange={(cardType: string) => {
            this.handleCardTypeChange(cardType);
            this.props.onChange(this.state.cardType);
          }}
          css={`validate ${valid || 'invalid'} ${cardTypeSelectUserClass}`}
        >
        <option value="" disabled={true}>
          Please select
        </option>
        {this.renderCardTypeOptions()}
        </Select>
        <label data-error={this.props.dataInvalidMessage}>
            {this.props.label || 'Title'}
        </label>
        </div>
      </>
    );
  }
}

export default SelectCardType;



// WEBPACK FOOTER //
// ./src/Components/SelectCardType.tsx